<template>
  <div class="bg-round bg-fff">
    <div class="container">
      <Bread class="ma-t-30" :list="[{path:'',name:'团队'}]"/>
      <header id="header">
        <div class="flex f-around">
          <div class="header-li" @click="$router.push('/about/team')">
            创始人Founder
          </div>
          <div
            class="header-li header-active"
            @click="$router.push('/merge/curator')"
          >
            策展团队Curator
          </div>
          <!-- <div class="header-li" @click="$router.push('/merge/jury')">
            评审团Jury
          </div> -->
          <div class="header-li" @click="$router.push('/merge/volunteer')">
            志愿者团队volunteer
          </div>
        </div>
      </header>
    </div>

    <div class="container line-height-35 main-md vhtml" id="app">
      <div v-html="Content"></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../../../css/bootstrap.min.css";
@import "../../../css/commons.css";
.about-text {
  line-height: 30px;
}

.img-a-bg {
  width: 100%;
  height: 285px;
  background: url("../../img/merge/a1.png") no-repeat;
  background-size: cover;
  background-position: center center;
  text-align: right;
  line-height: 285px;
}

.img-logo {
  width: 206px;
  height: 206px;
  margin-right: 40px;
}

.img-person {
  width: 220px;
}

@media (min-width: 768px) {
  .main-md {
    padding-left: 181px;
    padding-right: 210px;
  }
}
.video {
  width: 100%;
}
</style>
<script>
import { getOther } from "../../api.js";
export default {
  name: "merge",
  data() {
    return {
      footbottom: 123,
      Content: "",
      detail: "",
    };
  },
  created() {
    console.log("开始开发");
    this.getDetail();
  },

  methods: {
    //跳转链接
    toBanerHref() {
      let i = this.$refs.carousel.activeIndex;
      let item = this.bannerlist[i];
      console.log(item);
      if (!item.Href) {
        return;
      } else {
        location.href = item.Href;
      }
    },

    //获取数据
    getDetail() {
      let data = {
        code: "aboutus.curator",
      };
      getOther(data).then((res) => {
        console.log(res);
        this.detail = res.data.Data;
        this.Content = res.data.Data.Content;
      });
    },
  },
};
</script>
